import { get, post } from "../GenericServices";

const OrderApproval = {
  salApprovalSuppliers: (queryString) => {
    return get(`order-approval/suppliers?${queryString}`);
  },
  salApprovalOdaBySupplier: (queryString) => {
    return get(`order-approval/orders?${queryString}`);
  },
  salApprovalProjectTasksOrder: (queryString) => {
    return get(`order-approval/project-tasks-order?${queryString}`);
  },
  salApprovalConfirm: (data) => {
    return post(`order-approval/confirm`, data);
  },
};

export default OrderApproval;
